exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-button__account-button__255Go{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:inherit;font-size:14px}.account-button__account-button__255Go:hover{opacity:.7}.account-button__account-info-button-wrapper__1CPFI{-ms-flex-positive:0;flex-grow:0;height:20px;line-height:20px;border-radius:0}.account-button__account-info-button__2CtHg{font-size:28px;background:none;color:inherit;cursor:pointer}.account-button__account-info-button__2CtHg:hover{background:none;opacity:.7}", ""]);

// exports
exports.locals = {
	"account-button": "account-button__account-button__255Go",
	"accountButton": "account-button__account-button__255Go",
	"account-info-button-wrapper": "account-button__account-info-button-wrapper__1CPFI",
	"accountInfoButtonWrapper": "account-button__account-info-button-wrapper__1CPFI",
	"account-info-button": "account-button__account-info-button__2CtHg",
	"accountInfoButton": "account-button__account-info-button__2CtHg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/account/account-button/account-button.styl
// module id = 2901
// module chunks = 1